"use strict";

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aes_decrypt = exports.NativeLibContext = exports.Asset = void 0;
exports.assertNativeLib = assertNativeLib;
exports.importNativeLib = importNativeLib;
exports.importNativeLibCtx = importNativeLibCtx;
exports.isNativeLibLoaded = isNativeLibLoaded;
exports.unloadNativeLib = unloadNativeLib;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.typed-array.from.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

var _code = _interopRequireDefault(require("./code"));

var _golos_lib = _interopRequireDefault(require("./golos_lib"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _Asset = _golos_lib.default._Asset,
    aes256_decrypt = _golos_lib.default.aes256_decrypt;

var NativeLibContext = function NativeLibContext() {
  _classCallCheck(this, NativeLibContext);
};

exports.NativeLibContext = NativeLibContext;

var fromHexString = function fromHexString(str) {
  return new Uint8Array(str.match(/.{1,2}/g).map(function (byte) {
    return parseInt(byte, 16);
  }));
};

var fromBase64String = function fromBase64String(str) {
  if (typeof atob !== 'undefined') {
    return Uint8Array.from(atob(str), function (c) {
      return c.charCodeAt(0);
    });
  } else {
    return Buffer.from(str, 'base64');
  }
};

function importNativeLibCtx() {
  return _importNativeLibCtx.apply(this, arguments);
}

function _importNativeLibCtx() {
  _importNativeLibCtx = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var what;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!_code.default || !_golos_lib.default || !_Asset)) {
              _context.next = 3;
              break;
            }

            what = !_code.default ? 'wasm code' : 'init()';
            throw new Error("Native golos-lib core is not included into this golos-lib-js library. There is no ".concat(what, "."));

          case 3:
            _context.next = 5;
            return (0, _golos_lib.default)(fromBase64String(_code.default));

          case 5:
            return _context.abrupt("return", new NativeLibContext());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _importNativeLibCtx.apply(this, arguments);
}

var globalNativeCtx = null;

function importNativeLib() {
  return _importNativeLib.apply(this, arguments);
}

function _importNativeLib() {
  _importNativeLib = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!globalNativeCtx) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", globalNativeCtx);

          case 2:
            _context2.next = 4;
            return importNativeLibCtx();

          case 4:
            globalNativeCtx = _context2.sent;
            return _context2.abrupt("return", globalNativeCtx);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _importNativeLib.apply(this, arguments);
}

function unloadNativeLib() {
  globalNativeCtx = null;
}

function isNativeLibLoaded() {
  return !!globalNativeCtx;
}

function assertNativeLib(forWhat) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0.9.0';

  if (!isNativeLibLoaded()) {
    throw new Error("Starting from ".concat(version, ", golos-lib-js requires \"await golos.importNativeLib()\" before calling ").concat(forWhat));
  }
}

function wrapNative(orig) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var hasContext = args[0] instanceof NativeLibContext;

    if (!hasContext && !isNativeLibLoaded()) {
      return importNativeLib().then(function () {
        return orig.apply(void 0, _toConsumableArray(args));
      });
    }

    if (hasContext) {
      args = args.slice(1, args.length);
    }

    return orig.apply(void 0, _toConsumableArray(args));
  };
}

var Asset = wrapNative(function (amount, precision, symbol) {
  var a = null;

  if (precision !== undefined && symbol) {
    a = _Asset.new(amount, precision, symbol);
  } else {
    var str = amount;
    a = _Asset.fromString(str);
  }

  var wrapBinOp = function wrapBinOp(op) {
    return function (asset2) {
      if (!(asset2 instanceof _Asset)) return this["_".concat(op, "_num")](asset2);
      return this["_".concat(op)](asset2);
    };
  };

  _Asset.prototype.plus = wrapBinOp('plus');
  _Asset.prototype.minus = wrapBinOp('minus');
  _Asset.prototype.mul = wrapBinOp('mul');
  _Asset.prototype.div = wrapBinOp('div');
  return a;
});
exports.Asset = Asset;
var aes_decrypt = wrapNative(function (key, iv, data) {
  return aes256_decrypt(key, iv, data);
});
exports.aes_decrypt = aes_decrypt;